import { EntityKind } from '@/domain/model';

/**
 * What each kind of object is called in the list, for one that has no name of its own.
 *
 * `kindOf` returns the internal tag — `segment`, `function-graph` — and the list showed it
 * verbatim, so a teacher's inventory of their own drawing was written in English identifiers.
 * The label is what a Vietnamese lesson calls the thing, which is also what the toolbar button
 * that made it says.
 *
 * A `Record<EntityKind, string>` rather than a lookup with a fallback, so a new kind of object
 * cannot reach this list unnamed: the compiler refuses the file until somebody has decided what
 * to call it.
 */
export const KIND_NAMES: Readonly<Record<EntityKind, string>> = {
  [EntityKind.Solid]: 'khối',
  [EntityKind.AngleMark]: 'ký hiệu góc',
  [EntityKind.Point]: 'điểm',
  [EntityKind.Segment]: 'đoạn thẳng',
  [EntityKind.Ray]: 'tia',
  [EntityKind.Line]: 'đường thẳng',
  [EntityKind.Vector]: 'vectơ',
  [EntityKind.Circle]: 'đường tròn',
  [EntityKind.Arc]: 'cung tròn',
  [EntityKind.Ellipse]: 'elip',
  [EntityKind.Polygon]: 'đa giác',
  [EntityKind.Plane]: 'mặt phẳng',
  [EntityKind.Polyline]: 'đường gấp khúc',
  [EntityKind.Text]: 'chữ',
  [EntityKind.Measurement]: 'số đo',
  [EntityKind.Image]: 'ảnh',
  [EntityKind.FunctionGraph]: 'đồ thị',
  [EntityKind.Axes]: 'hệ trục',
  [EntityKind.VariationTable]: 'bảng biến thiên',
  [EntityKind.GraphMarks]: 'điểm đánh dấu',
};
